import styled from "styled-components";
import BG from "../../assets/background.png";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f8f8fa;
  z-index: 3;
  #hr {
    margin: 0% 3%;
    margin-top: 5rem;
    width: 94%;
    border-bottom: 1px solid #c4c4c4;
  }
  #hr1 {
    width: 100%;
    border-bottom: 1px solid #c4c4c4;
  }
  span {
    font-size: 1rem;
    margin: 0rem 2.68rem;
    color: #3a3b3c;
  }
  .justify-center {
    width: 100%;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    z-index: 1;

    .text-button{
        font-size: 1.2rem;
    }
  }
`;

export const Grid1 = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;

  h1 {
    font-size: 3.5rem;
    color: #f8f8f8;
    opacity: 0.85;
  }
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    filter: brightness(40%);
    background: url("${BG}") no-repeat center;
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
  }
  .home_text {
    display: flex;
    justify-content: center;
    margin-left: 2.68rem;
    width: 60%;
    z-index: 1;
  }

  @media screen and (max-width: 1150px) {
    h1 {
      font-size: 3.5rem;
    }
  }
  @media screen and (max-width: 950px) {
    h1 {
      font-size: 3rem;
    }
  }
  @media screen and (max-width: 610px) {
    h1 {
      font-size: 2.5rem;
    }
    .home_btn {
      margin: 1rem;
    }
  }
  @media screen and (max-width: 470px) {
    h1 {
      font-size: 2rem;
    }
  }
`;

export const Grid2 = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  color: #3a3b3c;
  h2 {
    font-weight: 600;
    font-size: 2.5rem;
    margin: 2rem 2.68rem;
  }

  .info {
    display: flex;
    justify-content: center;
    color: #3a3b3c;
    img {
      width: 40rem;
      object-fit: cover;
      display: flex;
    }
    .text {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 1.38rem;
      margin: 2rem 2.68rem;
    }
    .img {
      position: relative;
      top: -5rem;
      width: 15rem;
      margin: 0rem 2.68rem;
    }
  }
  @media screen and (max-width: 1150px) {
    .info {
      img {
        width: 30rem;
      }
    }
  }
  @media screen and (max-width: 899px) {
    .info {
      .img {
        width: 10rem;
      }
      img {
        width: 20rem;
        height: 15rem;
        margin: 2rem;
      }
    }
  }
  @media screen and (max-width: 760px) {
    .info {
      display: flex;
      flex-direction: column;
      .img {
        display: none;
      }
      img {
        width: 30rem;
      }
    }
  }
  @media screen and (max-width: 610px) {
    .info {
      img {
        width: 80%;
      }
    }
  }
`;

export const Programa = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0rem 2.68rem;
`;

export const SubPrograma = styled.section`
  display: flex;
  flex-direction: column;
  margin: 1rem 0rem;
  width: 25rem;
  border-radius: 5px;
  border: 1px solid #c4c4c4;
  img {
    width: 80%;
    height: 200px;
    object-fit: cover;
    margin: 1rem;
  }
  h2 {
    margin: 0.5rem;
    text-align: center;
    font-size: 1.3rem;
  }
  span {
    color: #353839;
    opacity: 0.9;
    text-align: center;
    margin: 1rem;
  }
`;

export const Beneficio = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .info-text {
    margin: 1rem 2.68rem;
    width: 43%;
    p {
      width: 100%;
      font-size: 1.75rem;
      margin: 0rem;
      .img {
        position: relative;
        top: 0.5rem;
        left: -0.5rem;
        float: right;
        width: 5.3rem;
      }
    }
    span {
      font-size: 1.3;
      color: #353839;
      margin: 0.5rem;
      width: 100%;
      margin: 0rem;
    }
  }

  @media screen and (max-width: 1244px) {
    .info-text {
      width: 40%;
      padding: 0.1rem;
    }
  }
  @media screen and (max-width: 911px) {
    .info-text {
      width: 38%;
      padding: 0.1rem;
    }
  }
  @media screen and (max-width: 760px) {
    .info-text {
      width: 80%;
      padding: 1rem;
    }
  }
`;

export const Info = styled.section`
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  h3 {
    text-align: center;
    font-weight: 200;
    font-size: 2rem;
    margin: 0rem 2.68rem;
    color: #3a3b3c;
  }
  h2 {
    text-align: center;
    font-weight: 600;
    font-size: 3.3rem;
    margin: 1rem 2.68rem;
    text-decoration: underline 2px;
    padding-bottom: 3rem;
    color: #3a3b3c;
  }
  div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    cursor: pointer;
    color: #3a3b3c;
  }

  @media screen and (max-width: 760px) {
    h3 {
      font-size: 2rem;
    }
    h2 {
      font-size: 2.5rem;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
